export function moveSelection(container, selectedIndex, direction) {
  const results = container.querySelectorAll(".searcher__result")
  if (results.length === 0) return selectedIndex

  results.forEach((r) => r.classList.remove("searcher__result--selected"))

  let newIndex = selectedIndex + direction
  if (newIndex >= results.length) newIndex = 0
  if (newIndex < 0) newIndex = results.length - 1

  const selected = results[newIndex]
  selected.classList.add("searcher__result--selected")
  selected.focus({ preventScroll: true })
  selected.scrollIntoView({ block: "nearest" })

  return newIndex
}

export function selectCurrent(container, selectedIndex) {
  const results = container.querySelectorAll(".searcher__result")
  const selected = results[selectedIndex]
  if (selected) {
    const href = selected.getAttribute("href")
    if (href) window.location.href = href
  }
}

export function syncSelectionFromFocus(container, event) {
  const results = Array.from(container.querySelectorAll(".searcher__result"))
  const focused = event.target.closest(".searcher__result")
  if (!focused) return -1

  results.forEach((r) => r.classList.remove("searcher__result--selected"))
  focused.classList.add("searcher__result--selected")
  return results.indexOf(focused)
}
